

export default class LeaveRequestModel {
    constructor() {
        this.id = undefined;
        this.employee = undefined;
        this.status = undefined;
        this.type = undefined;
        this.dateFrom = undefined;
        this.dateTo = undefined;
        this.description = undefined;
        this.rejectionReason = undefined;
        this.leftDaysNumber = undefined;
        this.annualLeaveTotalDays = undefined;
        this.annualLeaveLeftDays = undefined;
        this.annualLeaveOverdueDays = undefined;
        this.annualLeaveUsedDays = undefined;
        this.read = undefined;
        this.absenceReason = undefined;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id ? from.id : undefined;
            to.employee = from?.employee ? from.employee : [];
            to.status = from.status ? from.status : undefined;
            to.type = from.type ? from.type : undefined;
            to.dateFrom = from.dateFrom ? from.dateFrom : null;
            to.dateTo = from.dateTo ? from.dateTo : null;
            to.description = from.description ? from.description : undefined;
            to.rejectionReason = from.rejectionReason ? from.rejectionReason : undefined;
            to.leftDaysNumber = from.leftDaysNumber ?  from.leftDaysNumber : undefined;
            to.annualLeaveTotalDays = from.annualLeaveTotalDays ? from.annualLeaveTotalDays : 0;
            to.annualLeaveLeftDays = from.annualLeaveLeftDays ? from.annualLeaveLeftDays : 0;
            to.annualLeaveOverdueDays = from.annualLeaveOverdueDays ? from.annualLeaveOverdueDays : 0;
            to.annualLeaveUsedDays = from.annualLeaveUsedDays ? from.annualLeaveUsedDays : 0;
            to.read = from.read ? from.read : false;
            to.absenceReason = from.absenceReason ? from.absenceReason : undefined;
         }
       
    }

    static copy(from) {
        const to = new LeaveRequestModel();
        LeaveRequestModel.assign(from, to);
        return to;
    }
}
